import React from 'react';
import Img from 'gatsby-image';
import { Link } from 'gatsby';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Display = _ref => {
  let {
    items,
    noLink,
    colCount
  } = _ref;
  return ___EmotionJSX(S.Container, null, items.map(item => {
    const {
      title,
      link,
      image,
      description
    } = item;
    return ___EmotionJSX(S.Item, {
      colCount: colCount ? colCount : items.length,
      key: title,
      as: noLink ? 'div' : Link,
      to: link
    }, ___EmotionJSX("div", null, ___EmotionJSX(Img, {
      fluid: image.childImageSharp.fluid,
      alt: title
    }), ___EmotionJSX("h4", null, title)), ___EmotionJSX("p", {
      dangerouslySetInnerHTML: {
        __html: description
      }
    }));
  }));
};
export default Display;